export function getViralSubstitutionMarker(
  baseX: number,
  baseY: number,
  baseOffset: number
): string {
  return `
      ${baseX} ${baseY}, 
      ${baseX + baseOffset} ${baseY - baseOffset}, 
      ${baseX + baseOffset * 2} ${baseY}, 
      ${baseX + baseOffset} ${baseY + baseOffset}
    `;
}

export function getViralDeletionMarker(baseX: number, baseY: number, baseOffset: number): string {
  return `
      ${baseX} ${baseY}, 
      ${baseX + baseOffset} ${baseY + baseOffset}, 
      ${baseX + baseOffset * 2} ${baseY},
    `;
}

export function getViralInsertionMarker(baseX: number, baseY: number, baseOffset: number): string {
  return `
      ${baseX} ${baseY}, 
      ${baseX + baseOffset} ${baseY - baseOffset}, 
      ${baseX + baseOffset * 2} ${baseY}, 
    `;
}
